// Возврат наверх
let arrowUp = document.querySelector('.up__arrow');
arrowUp.addEventListener('click', (e) => {
	e.preventDefault();
	window.scrollTo({
		top: 0,
		behavior: 'smooth',
	});
});
